"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.COLOR_PATH_MAPPER = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var styles_1 = require("@mui/material/styles");
var get_1 = __importDefault(require("lodash/get"));
var Text_1 = __importDefault(require("shared/components/Text"));
exports.COLOR_PATH_MAPPER = {
    neutral: 'neutral.main',
    error: 'error.main',
    success: 'success.dark',
};
var StyledIcon = (0, styles_1.styled)(react_fontawesome_1.FontAwesomeIcon)({
    '&.fa-xs': {
        fontSize: '0.625rem',
    },
    '&.svg-inline--fa.fa-fw': {
        width: '0.625rem',
    },
});
var BadgeWrapper = (0, styles_1.styled)('div')(function (_a) {
    var theme = _a.theme, color = _a.color;
    return ({
        color: color && (0, get_1.default)(theme.palette, exports.COLOR_PATH_MAPPER[color] || ''),
        display: 'inline-block',
    });
});
var StatsBadge = function (_a) {
    var label = _a.label, icon = _a.icon, size = _a.size, _b = _a.color, color = _b === void 0 ? 'error' : _b;
    return ((0, jsx_runtime_1.jsxs)(BadgeWrapper, __assign({ color: color }, { children: [(0, jsx_runtime_1.jsx)(StyledIcon, { icon: icon, size: size, fixedWidth: true }), (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1, sx: { ml: 0.5 }, component: "span" }, { children: label }))] })));
};
exports.default = StatsBadge;
